import { createContext } from 'preact';
import { useEffect, useState, useContext, useCallback } from 'preact/hooks';
import { html } from '@utils/rendering/html';

const FeatureContext = createContext({});

export function FeatureProvider({ children }) {
    const [map, setMap] = useState({});

    async function load() {
        const response = await fetch('/api/features', { credentials: 'include' });
        if (response.ok) setMap(await response.json());
    }

    useEffect(() => {
        load();
        const time = setInterval(load, 300_000);
        return () => clearInterval(time);
    }, []);

    const useFeature = useCallback(
        (key, fallback) => {
            return map[key] ? map[key] : fallback;
        },
        [map]
    );

    return html`
        <${FeatureContext.Provider}
            value=${{ map, useFeature }}>
            ${children}
        </${FeatureContext.Provider}>
    `;
}

export const useFeatureChecks = () => useContext(FeatureContext);
